var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex mt-4"},[_c('MediaContainer',{attrs:{"slot":"left","readOnly":"","onlyThumbnails":"","smallThumbnails":"","images":_vm.response},slot:"left"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }